export enum TemplatesHistory {
  SELECT_TEMPLATE = "SELECT_TEMPLATE",
  GET_TEMPLATES = "GET_TEMPLATES",
  GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS",
  GET_TEMPLATES_FAIL = "GET_TEMPLATES_FAIL",

  GET_TEMPLATE_DATA = "GET_TEMPLATE_DATA",
  GET_TEMPLATE_DATA_SUCCESS = "GET_TEMPLATE_DATA_SUCCESS",
  GET_TEMPLATE_DATA_FAIL = "GET_TEMPLATE_DATA_FAIL",

  ADD_NEW_PAGE = "ADD_NEW_PAGE",
  ADD_NEW_PAGE_SUCCESS = "ADD_NEW_PAGE_SUCCESS",
  ADD_NEW_PAGE_FAIL = "ADD_NEW_PAGE_FAIL",
  DELETE_PAGE = "DELETE_PAGE",

  INIT_TEMPLATES = "INIT_TEMPLATES",

  GET_DOCUMENT_TYPES = "GET_DOCUMENT_TYPES",
  GET_DOCUMENT_TYPES_SUCCESS = "GET_DOCUMENT_TYPES_SUCCESS",
  GET_DOCUMENT_TYPES_FAIL = "GET_DOCUMENT_TYPES_FAIL",

  IMPORT_TEMPLATE_DATA = "IMPORT_TEMPLATE_DATA",
  IMPORT_TEMPLATE_DATA_SUCCESS = "IMPORT_TEMPLATE_DATA_SUCCESS",
  IMPORT_TEMPLATE_DATA_FAIL = "IMPORT_TEMPLATE_DATA_FAIL",

  SET_PAGE_PROPERTIES = "SET_PAGE_PROPERTIES",
  UPDATE_TEMPLATE_DATA = "UPDATE_TEMPLATE_DATA",

  SAVE_TEMPLATE_DATA = "SAVE_TEMPLATE_DATA",
  SAVE_TEMPLATE_DATA_SUCCESS = "SAVE_TEMPLATE_DATA_SUCCESS",
  SAVE_TEMPLATE_DATA_FAIL = "SAVE_TEMPLATE_DATA_FAIL",

  DELETE_SECTION = "DELETE_SECTION",

  FILTER_TEMPLATES = "FILTER_TEMPLATES",

  COPY_TEMPLATE = "COPY_TEMPLATE",
  COPY_TEMPLATE_SUCCESS = "COPY_TEMPLATE_SUCCESS",
  COPY_TEMPLATE_FAIL = "COPY_TEMPLATE_FAIL",
  COPY_TEMPLATE_COMPLETED = "COPY_TEMPLATE_COMPLETED",

  HANDLE_CONFIRM_EXIT_MODAL = "HANDLE_CONFIRM_EXIT_MODAL",

  SORT_TEMPLATES = "SORT_TEMPLATES",

  GET_TEMPLATE_VERSIONS_HISTORY = "GET_TEMPLATE_VERSIONS_HISTORY",
  GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS = "GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS",
  GET_TEMPLATE_VERSIONS_HISTORY_FAIL = "GET_TEMPLATE_VERSIONS_HISTORY_FAIL",

  RESET_TEMPLATE_VERSIONS_HISTORY = "RESET_TEMPLATE_VERSIONS_HISTORY"
}
